import React, { useEffect, useState } from 'react';
import axios from 'axios';
import AdminLayout from '../../components/admin/AdminLayout';

const STATUS_COLORS = {
  new:      { bg: '#fef9c3', color: '#a16207' },
  read:     { bg: '#f0f9ff', color: '#0369a1' },
  replied:  { bg: '#f0fdf4', color: '#15803d' },
  archived: { bg: '#f8fafc', color: '#64748b' },
};

const AdminContacts = () => {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');
  const [selected, setSelected] = useState(null);
  const [success, setSuccess] = useState('');

  const load = async () => {
    setLoading(true);
    try {
      const params = {};
      if (filter !== 'all') params.status = filter;
      const res = await axios.get('/api/admin/contacts', { params });
      setContacts(res.data.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, [filter]);

  const updateStatus = async (id, status) => {
    await axios.put(`/api/admin/contacts/${id}/status`, { status });
    setSuccess('Status updated.');
    setTimeout(() => setSuccess(''), 3000);
    load();
    if (selected?._id === id) setSelected(s => ({ ...s, status }));
  };

  const deleteContact = async (id) => {
    if (!window.confirm('Delete this contact submission?')) return;
    await axios.delete(`/api/admin/contacts/${id}`);
    setSelected(null);
    load();
  };

  const FILTERS = ['all', 'new', 'read', 'replied', 'archived'];

  return (
    <AdminLayout>
      <div>
        <h1 style={{ fontSize: '20px', fontWeight: 700, color: '#0f172a', marginBottom: '16px' }}>Contact Submissions</h1>

        {success && <div style={{ background: 'rgba(34,197,94,0.1)', border: '1px solid rgba(34,197,94,0.3)', borderRadius: '6px', padding: '8px 14px', marginBottom: '12px', color: '#16a34a', fontSize: '13px' }}>{success}</div>}

        {/* Filter tabs */}
        <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
          {FILTERS.map(f => (
            <button key={f} onClick={() => setFilter(f)} style={{ padding: '6px 14px', borderRadius: '6px', border: 'none', fontSize: '13px', cursor: 'pointer', background: filter === f ? '#3b82f6' : '#f1f5f9', color: filter === f ? '#fff' : '#475569', fontWeight: filter === f ? 600 : 400 }}>
              {f.charAt(0).toUpperCase() + f.slice(1)}
            </button>
          ))}
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: selected ? '1fr 1fr' : '1fr', gap: '16px' }}>
          {/* List */}
          <div style={{ background: '#fff', borderRadius: '10px', border: '1px solid #e2e8f0', overflow: 'hidden' }}>
            {loading ? (
              <div style={{ padding: '24px', textAlign: 'center', color: '#64748b' }}>Loading…</div>
            ) : contacts.length === 0 ? (
              <div style={{ padding: '24px', textAlign: 'center', color: '#94a3b8' }}>No submissions.</div>
            ) : (
              contacts.map((c, i) => (
                <div key={c._id} onClick={() => setSelected(c)} style={{
                  padding: '12px 16px',
                  borderBottom: i < contacts.length - 1 ? '1px solid #f1f5f9' : 'none',
                  cursor: 'pointer',
                  background: selected?._id === c._id ? '#f0f9ff' : c.status === 'new' ? '#fffbeb' : '#fff',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start',
                  gap: '8px'
                }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '2px' }}>
                      <span style={{ fontWeight: 600, fontSize: '13px', color: '#0f172a' }}>{c.name}</span>
                      <span style={{ fontSize: '11px', padding: '1px 7px', borderRadius: '9999px', ...STATUS_COLORS[c.status] }}>{c.status}</span>
                    </div>
                    <div style={{ fontSize: '12px', color: '#64748b', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.subject}</div>
                    <div style={{ fontSize: '11px', color: '#94a3b8', marginTop: '2px' }}>{new Date(c.createdAt).toLocaleDateString()}</div>
                  </div>
                </div>
              ))
            )}
          </div>

          {/* Detail */}
          {selected && (
            <div style={{ background: '#fff', borderRadius: '10px', border: '1px solid #e2e8f0', padding: '20px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
                <div>
                  <h2 style={{ fontSize: '16px', fontWeight: 700, color: '#0f172a', margin: '0 0 4px' }}>{selected.name}</h2>
                  <a href={`mailto:${selected.email}`} style={{ fontSize: '13px', color: '#3b82f6', textDecoration: 'none' }}>{selected.email}</a>
                  {selected.company && <div style={{ fontSize: '13px', color: '#64748b', marginTop: '2px' }}>{selected.company}</div>}
                </div>
                <button onClick={() => setSelected(null)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#94a3b8', fontSize: '18px' }}>×</button>
              </div>

              <div style={{ background: '#f8fafc', borderRadius: '6px', padding: '12px', marginBottom: '16px' }}>
                <div style={{ fontSize: '12px', fontWeight: 600, color: '#475569', marginBottom: '6px', textTransform: 'uppercase' }}>{selected.subject}</div>
                <p style={{ fontSize: '13px', color: '#334155', margin: 0, lineHeight: '1.6', whiteSpace: 'pre-wrap' }}>{selected.message}</p>
              </div>

              <div style={{ fontSize: '11px', color: '#94a3b8', marginBottom: '16px' }}>{new Date(selected.createdAt).toLocaleString()}</div>

              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                {['new', 'read', 'replied', 'archived'].map(s => (
                  <button key={s} onClick={() => updateStatus(selected._id, s)}
                    style={{ padding: '5px 12px', borderRadius: '6px', border: 'none', fontSize: '12px', cursor: 'pointer', background: selected.status === s ? '#3b82f6' : '#f1f5f9', color: selected.status === s ? '#fff' : '#475569', fontWeight: selected.status === s ? 600 : 400 }}>
                    Mark {s}
                  </button>
                ))}
                <button onClick={() => deleteContact(selected._id)} style={{ padding: '5px 12px', borderRadius: '6px', border: 'none', fontSize: '12px', cursor: 'pointer', background: '#fef2f2', color: '#ef4444' }}>
                  Delete
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminContacts;
